import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { spxToasterActions, SpxToasterAutoCloseSpeedEnum } from '@softpak/components/spx-toaster';
import { SpxCapitalizePipe } from '@softpak/components/spx-capitalize';
import { textCopiedToClipboard } from 'src/app/shared/_config/i18n/i18n-interface';
import { Clipboard } from '@capacitor/clipboard';
import { TranslateService } from '@ngx-translate/core';
import { copyToClipboard } from './shared-clipboard.actions';

@Injectable()
export class SharedClipboardEffects {
    // Injects
    private readonly actions$ = inject(Actions);
    private readonly translateService = inject(TranslateService);

    copyToClipboard$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(copyToClipboard),
        mergeMap((action) => {
            Clipboard.write({
                string: action.message,
            })
            return [
                spxToasterActions.clearAll(),
                spxToasterActions.createSuccess({
                    autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                    messageText: SpxCapitalizePipe.transform(this.translateService.instant(textCopiedToClipboard)),
                }),
            ];
        }))
    );
}
